export default __webpack_public_path__ + "static/media/GalanoGrotesque-SemiBoldItalic.19e4abe5.woff";